<template>
	<div 
	>

		<el-form 
			ref="form" 
			label-width="100px"
			:baseModel="baseModel"
		>
			<x-form
				label="打卡小组标题"
				prop="group_name"
				placeholder="请输入标题"
				required
				v-model="createModel.group_name"
			></x-form>
			<x-form
				label="小组类型"
				type="radio"
				:options="groupOpts"
				prop="visible_type"
				required
				v-model="createModel.visible_type"
			></x-form>
			<x-form
				label="标签"
				type="cascader"
				:defaultKey="labelOpts"
				prop="label_id"
				v-model="label_name"
			></x-form>
			<x-form
				label="标签名称"
				v-model="labelName"
				disabled
				v-if="createModel.id && !label_name.length"
			></x-form>
			<x-form
				label="打卡小组描述"
				prop="group_intro"
				placeholder="请输入描述"
				required
				v-model="createModel.group_intro"
			></x-form>
			<x-form
				label="组长ID"
				prop="uid"
				placeholder="请输入小组组长的用户ID"
				required
				v-model="createModel.uid"
			></x-form>
			<x-form
				label="打卡小组图标"
				prop="group_icon"
				type="image"
				v-model="createModel.group_icon"
			></x-form>
			<x-form
				label="打卡日期"
				type="daterange"
				prop="cardTime"
				required
				valueFormat="yyyy-MM-dd"
				v-model="cardTime"
			></x-form>
			<x-form
				label="上下线时间"
				type="daterange"
				prop="onlineTime"
				valueFormat="yyyy-MM-dd"
				required
				v-model="onlineTime"
			></x-form>
			<!-- <x-form
				label="定时提醒"
				prop="title"
				required
				v-model="createModel.group_name"
			></x-form> -->
			<x-form
				label="可补打卡次数"
				type="number"
				prop="max_sign_in_replenish"
				v-model="createModel.max_sign_in_replenish"
			></x-form>
			<x-form
				label="当天打卡次数"
				prop="max_sign_in_num"
				type="radio"
				required
				:options="cardOpts"
				v-model="createModel.max_sign_in_num"
			></x-form>

			<x-form label="参与方式设置" type="boxed">
				<div class="join-way" slot="box">
					<el-radio
						:label="1"
						v-model="createModel.join_type"
					>任何人可参加</el-radio>
					<el-radio
						:label="2"
						v-model="createModel.join_type"
						>输入指定口令参加</el-radio>
					<x-form
						label="设置口令："
						placeholder="请输入口令"
						v-model="createModel.join_code"
					></x-form>
					<x-form
						label="设置获取口令链接地址："
						placeholder="请输入口令链接地址"
						v-model="createModel.join_url"
					></x-form>
					<el-radio
						:label="3"
						v-model="createModel.join_type"
						>邀请书友助力参加</el-radio>
					<x-form
						label="设置人数"
						type="number"
						prop="join_invite_user"
						max="3"
						v-model="createModel.join_invite_user"
						min="1"
						append="（最小为1，最大为3的整数）"
					></x-form>
					<el-radio
						:label="4"
						v-model="createModel.join_type"
						>审核材料参加</el-radio>
					<x-form
						label="规则说明："
						type="textarea"
						prop="join_audit_rule"
						v-model="createModel.join_audit_rule"
					></x-form>
					<x-form
						label="图片数量"
						type="number"
						max="3"
						prop="join_audit_img_num"
						min="1"
						v-model="createModel.join_audit_img_num"
						append="（最小为1，最大为3的整数）"
					></x-form>
					<x-form
						label="审核方式："
						type="radio"
						prop="join_audit_type"
						v-model="createModel.join_audit_type"
						:options="auditOpts"
					></x-form>
				</div>
			</x-form>

			<x-form
				label="权限设置"
				type="radio"
				:options="limitOpts"
				prop="show_type"
				v-model="createModel.show_type"
			></x-form>
		</el-form>

		<div class="footer-wrapper">
			<el-button @click="cancel">取消</el-button>
			<el-button type="primary" @click="confirm">保存</el-button>
		</div>
	</div>
</template>

<script type="text/javascript">
import {
	saveGroup,
	getLabelList
} from '@/api/group';
import {deepClone} from '@/utils/util';
const createModel = {
	group_name: '', //组名称
	group_intro: '', //组简介
	group_icon: '', //组图标
	uid: '', //组长id
	join_type: 1, //加入方式 1、无 2、口令 3、邀请 4、审核
	join_code: '', //组邀请码
	join_invite_user: 1, //加入组邀请几人
	join_audit_type: 1, //组审核方式，1自动审核，2 手动审核
	join_audit_img_num: 1, //加入组，需上传图片数量
	show_type: 1, //组展示范围 1 任意人 2 组员
	sign_in_online_time: '', //打卡上线时间
	sign_in_offline_time: '', //打卡下线时间
	sign_in_start_time: '', //打卡开始时间
	sign_in_end_time: '', //打卡结束时间
	join_audit_rule: "", // 审核规则
	max_sign_in_replenish: 0, // 最大补卡次数 
    max_sign_in_num: 1, // 最大打卡次数 -1为不限次数，1为可打卡一次
    join_url: '', // 口令地址
	visible_type: 1,
	label_id:''
}

export default {
	data() {
		return {
			
			cardTime: [],
			onlineTime: [],
			limitOpts: [
				{
					label: '任何人可见',
					value: 1
				},
				{
					label: '仅小组成员可见',
					value: 2
				}
			],
			groupOpts: [
				{
					label: '公开小组',
					value: 1
				},
				{
					label: '私密小组',
					value: 2
				}
			],
			createModel,
			baseModel: deepClone(createModel),
			way: '1',
			auditOpts: [
				{
					label: '自动审核',
					value: 1
				},
				{
					label: '手动审核',
					value: 2
				}
			],
			cardOpts: [
				{
					label: '只能打卡一次',
					value: 1
				},
				{
					label: '不限次数',
					value: -1
				}
			],
			labelOpts:{
				lazy: true,
				lazyLoad (node, resolve) {
					const { level, value } = node;
					console.log(level)
					 getLabelList({
						pId: value ?? 0,
					}).then((res) => {
						let temp = res.data.resp.data;
						temp.forEach(item => {
							item.leaf = level >= 1
						});
						resolve(temp);
					});
				},
				value: 'id',
				label: 'name',
			},
			label_name:'',
			labelName: ''
		};
	},
	props: {
		close: Function,
		fetchList: Function,
	},
	methods: {
		deepClone,
		cancel() {
			this.close()
		},
		resetForm() {
			this.reset(this.$refs.form)
		},
		show(row, type) {
			//先清空数据
			this.createModel.label_id = '';
			this.label_name = '';
			this.labelName = '';
			this.cardTime = [];
			this.onlineTime = [];

			if (row) {

				this.createModel = deepClone(row)

				delete this.createModel.updated_at
				delete this.createModel.created_at

				this.cardTime = [row.sign_in_start_time, row.sign_in_end_time]
				this.onlineTime = [row.sign_in_online_time, row.sign_in_offline_time]
				this.labelName = row.label.parentLabelName+'-'+row.label.labelName
				this.createModel.label_id = row.label.labelId

				this.$forceUpdate()
			} else {
				this.createModel = deepClone(this.baseModel)
			}



			if (type == 'copy') {

				delete this.createModel.id
				
			}

		},
		confirm() {
			const value = this.validatorForm(this.$refs.form)

			if (value) return
			const {join_type, join_code} = this.createModel;
			const [startTime, endTime] = this.cardTime
			const [onlineTime, offlineTime] = this.onlineTime
			
			if (new Date(onlineTime) > new Date(startTime)) {
				this.$message.warning('打卡上线时间不能大于打卡开始时间')
				return
			}
			if (new Date(offlineTime) < new Date(endTime)) {
				this.$message.warning('打卡下线时间不能小于打卡结束时间')
				return
			}

			this.createModel.sign_in_online_time = onlineTime + ' 00:00:00'
			this.createModel.sign_in_offline_time = offlineTime + ' 23:59:59'
			this.createModel.sign_in_start_time = startTime + ' 00:00:00'
			this.createModel.sign_in_end_time = endTime + ' 23:59:59'

			if (join_type == 2 && !join_code) {
				this.$message.warning('口令不能为空')
				return
			}


			saveGroup({
				...this.createModel,
				join_audit_img_num: this.createModel.join_audit_img_num - 0,
				join_invite_user: this.createModel.join_invite_user - 0,
				max_sign_in_replenish: this.createModel.max_sign_in_replenish - 0,
				uid: this.createModel.uid - 0,
				max_sign_in_num: parseInt(this.createModel.max_sign_in_num),
				label_id: this.label_name.length ? this.label_name[1] : this.createModel.label_id,
				is_recommend: this.createModel.visible_type == 1 ? 2 : 1
			}).then(res => {
				this.$emit('success')
				this.$message.success('保存成功')
				this.cancel()
				this.fetchList()
			})

		}
	}
};
</script>

<style lang="less">
.join-way {
	.el-radio {
		display: block;
		margin-bottom: 10px;
	}
}
</style>
